<template>
  <div>
    <v-dialog v-model="alertDialog" width="auto" max-width="500">
      <v-card>
        <v-card-text :class="`py-5 text-center ${classColor}`">
          <slot></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PageName",
  computed: {
    alertDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    alertDialog(value) {
      if (value) {
        setTimeout(() => {
          this.alertDialog = false;
        }, this.timeout);
      }
    },
  },
  created() {},
  data() {
    return {};
  },
  props: {
    value: Boolean,
    classColor: String,
    timeout: Number,
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
